
import { Inject, Options, Provide, Vue, Watch } from "vue-property-decorator";
import SwipeStepper from "../swipe-stepper/index.vue";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { TrustAPI } from "@/shared/modules/trust-api";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import { RouteN } from "@/trust-atcs-app/constants/router-name";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ConfirmDialogue from '@/shared/components/confirm-dialogue/index.vue';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import FormHeader from "../form-header/index.vue";
import FormHeaderTcNote from "../form-header-tc-note/index.vue";
import SessionExpired from "../session-expired-modal/index.vue";
import FirmSelector from "../firm-selector/index.vue";
import PracticePeopleSignatories from "../practice-people-signatories/index.vue";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { SolelyJointly } from "@/shared/modules/typescript-trustapi-client/models";
import LoggedInElsewhere from "../loggedin-elsewhere-modal/index.vue";
import AccessDenied from "../access-denied-modal/index.vue";
import { IDLESessionManager } from "@/trust-atcs-app/modules/session/idle-session-manager";



@Options({
  components: {
    LoadingSpinner,
    FirmSelector,
    PracticePeopleSignatories,
    LoggedInElsewhere,
    SessionExpired,
    AccessDenied
  },
  mixins: [FormatDateTimeMixin],
})
export default class ManageAuthorisedSignatories extends Vue {
  // private formPartADataStore = useFormPartADataStore();

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Provide({ to: 'solelyJointlyType', reactive: true })
  private solelyJointlyType!: SolelyJointly[];

  @Provide({ to: 'categoriesType', reactive: true })
  private categoriesType!: any[];

  private practices: any[] = [];
  private selectedPractice: any = null;
  private authorisedSignatories: any[] = [];
  private isLoadingPractices = false;

  private loadingData = false;
  private errorLoadingData = false;

  private showLoggedInElsewhereModal = false;
  private showSessionExpiredModal = false;
  private showAccessDeniedModal = false;
  private firstNameProp = '';
  private lastNameProp = '';

  private workerID: any = null;
  private stopExtending = false;
  private isSaving = false;

  private typeA = false;
  private typeB = false;
  private typeC = false;



  private ai = new AppInsights;


  private idleSessionMgr: IDLESessionManager = new IDLESessionManager(60);

  created(): void {
    store.dispatch('setSignatoriesUpdatingKey', null);
    store.dispatch('setSelectedPracticeCoreId', null);
    this.idleSessionMgr.run(this.idleSessionTimeoutCallback);
    this.workerID = setInterval(() => {
      if (this.signatoriesPracticeCoreId && this.signatoriesUpdatingKey) {
        this.extendSession();
      }
    }, 30000);
    this.loadDependencyData();
  }

  mounted(): void {
    this.eventCtrl.on('save-and-close', this.releaseAndClose);
  }

  beforeUnmount(): void {
    clearInterval(this.workerID);
    this.eventCtrl.off('save-and-close', this.releaseAndClose);
  }


  private async loadDependencyData(): Promise<void> {
    try {
      this.loadingData = true;
      this.errorLoadingData = false;
      const resp: any[] = await Promise.all([
        this.apiService.CodeApi?.apiV2CodeGetSolelyJointliesGet(),
        this.apiService.CodeApi?.apiV2CodeGetCategoriesGet(),
        this.loadPractices()

      ]);
      this.solelyJointlyType = resp[0].data.data as SolelyJointly[];
      this.categoriesType = resp[1].data.data;
    } catch (error) {
      this.errorLoadingData = true;
      console.log(error);
    } finally {
      this.loadingData = false;
    }
  }


  private setSelectedPractice(practice: any): void {
    this.selectedPractice = practice;
    store.dispatch('setSelectedPracticeCoreId', practice.practiceCoreId);
    console.log(this.selectedPractice, practice);
    //this.loadAuthorisedSignatories();
  }

  private async loadPractices(): Promise<void> {
    try {
      this.isLoadingPractices = true;
      const resp: any = await this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeGetMyPracticesGet();
      this.practices = resp.data.data;

      const practiceCoreId = Number(this.$route.query?.practiceCoreId)
      if (practiceCoreId) {
        const selected = this.practices.find(p => p.practiceCoreId === practiceCoreId);
        if (selected) {
          this.setSelectedPractice(selected);
        } else {
          this.$router.replace({ name: RouteN.ATCS.DashboardMain.n });
        }
      } else if (practiceCoreId === null || practiceCoreId === 0) {
        if (this.practices.length == 1) {
          this.setSelectedPractice(this.practices[0]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingPractices = false;
      console.log('done getting practices');
    }
  }

  private idleSessionTimeoutCallback(): void {
    this.stopExtending = true;
  }

  private async extendSession(): Promise<void> {
    try {
      if (this.stopExtending) {
        clearInterval(this.workerID);
        this.showSessionExpiredModal = true;
        return;
      }
      if (this.isSaving) {
        return;
      }
      await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleRenewManageSignatoryLockPost(
        {
          practiceCoreId: this.selectedPractice.practiceCoreId,
          updatingKey: this.signatoriesUpdatingKey
        }
      );

    } catch (err) {
      clearInterval(this.workerID);
      this.showSessionExpiredModal = true;
    }
  }

  private handleError(errorData: any): void {
    this.typeA = false;
    this.typeB = false;
    this.typeC = false;
    
    console.log('Error Data: ', errorData);
    if (errorData.errorCode) {
      switch (errorData.errorCode) {
        case 100001:
          this.typeA = true;
          this.showAccessDeniedInfo(errorData);
          break;
        case 100002:
          this.showLoggedInElsewhereModal = true;
          break;
        case 100003:
          this.showSessionExpiredModal = true;
          break;
        case 100004:
          this.typeB = true;
          this.showAccessDeniedModal = true;
          break;
        case 100005:
          this.typeC = true;
          this.showAccessDeniedModal = true;
          break;
        default:
          break;
      }
    }
  }

  private showAccessDeniedInfo(errorData: any = null): void {

    this.firstNameProp = errorData?.updatingBy?.firstName ?? '';
    this.lastNameProp = errorData?.updatingBy?.lastName ?? '';
    this.showAccessDeniedModal = true;

  }

  private closeLoggedInElsewhereModal(): void {
    if (this.practices.length > 1) {
      this.selectedPractice = null;
      this.showLoggedInElsewhereModal = false;
    } else {
      this.$router.push({ name: RouteN.ATCS.DashboardHome.n });
    }
  }

  private async proceedToOvertakeSession(): Promise<void> {
    let resp: any = null;

    try {
      this.isSaving = true;
      resp = await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(this.selectedPractice.practiceCoreId);
      this.showLoggedInElsewhereModal = false;
      this.setSelectedPractice(this.selectedPractice);
      store.dispatch('setSignatoriesUpdatingKey', null);
      this.eventCtrl.emit('loadSignatoriesData');

    } catch (err: any) {
      // this.ai.trackException('Error kicking out existing session: ' + err);
      // this.eventCtrl.emit('show-snackbar', 'error', 'Error kicking out existing session: ' + err);
    } finally {
      this.isSaving = false;
    }
  }

  private closeAccessDeniedModal(): void {
    this.firstNameProp = '';
    this.lastNameProp = '';
    if (this.practices.length > 1) {
      this.selectedPractice = null;
      this.showAccessDeniedModal = false;
    } else {
      this.$router.push({ name: RouteN.ATCS.DashboardHome.n });
    }
  }

  private exitPage(): void {
    this.stopExtending = true;
    clearInterval(this.workerID);
    this.$router.push({ name: RouteN.ATCS.DashboardHome.n });
    this.showSessionExpiredModal = false;
  }

  private loadingStateChanged(loadingStatus: boolean): void {
    this.isSaving = loadingStatus;
  }

  private async releaseAndClose(): Promise<void> {
    // this.stopExtending = true;
    // clearInterval(this.workerID);
    // this.$router.push({ name: RouteN.ATCS.DashboardHome.n });

    if (!this.selectedPractice) {
      this.$router.push({ name: RouteN.ATCS.DashboardMain.n });
      return;
    }

    let resp: any = null;

    try {
      this.isSaving = true;
      resp = await this.apiService.PeopleAtcsApi?.apiV2AtcsPeopleForceReleaseManageSignatoryLockPracticeCoreIdDelete(this.selectedPractice.practiceCoreId);
      this.$router.push({ name: RouteN.ATCS.DashboardMain.n });

    } catch (err: any) {
      // this.ai.trackException('Error kicking out existing session: ' + err);
      // this.eventCtrl.emit('show-snackbar', 'error', 'Error kicking out existing session: ' + err);
    } finally {
      this.isSaving = false;
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }
}





